module.exports = __webpack_public_path__ + "static/media/jug.fed653b0.svg";